module.exports = __webpack_public_path__ + "static/media/lounge.0a81973c.PNG";